"use client";
import React, { useEffect, useCallback } from "react";
import { useRouter } from "next/navigation";
import Cookies from "js-cookie";

const Page = () => {
    const router = useRouter();

    const isAuthenticated = useCallback(() => {
        return !!Cookies.get("lazulite_token");
    }, []);

    useEffect(() => {
        if (isAuthenticated()) {
            router.push("/redirect");
        } else {
            router.push("/auth/signup");
        }
    }, [router, isAuthenticated]);

    return <div>.</div>;
};

export default Page;
